import VXEStore from './store'

const formats = new VXEStore()

export default formats
